"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOfferItemsPage = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _utils = require("../utils");
// istanbul ignore file -- api
/**
 * Fetch function to get a page of products for an offer.
 */ const getOfferItemsPage = async (param)=>{
    let { atpClusterId, customerTypeId, globalApiClient, lang, offerId, requestParams, sessionId, staticApiClient, tenant, visitorSegment } = param;
    const { data: { collection, totalRecords } } = await (0, _globalApiClientReact.getShoppingSessionOfferOfferItems)(globalApiClient, sessionId, offerId, requestParams);
    const productCodes = collection.map((item)=>item.itemCode).filter((x)=>x !== undefined);
    if (productCodes.length === 0) {
        return {
            offerItems: [],
            totalRecords: 0
        };
    }
    const { data: { data: { products } = {
        products: []
    } } } = await (0, _staticApiClientReact.getTenantApplicationsProductBox)(staticApiClient, tenant, {
        lang,
        productCodes,
        atpClusterId,
        customerTypeId,
        visitorSegment
    });
    return {
        offerItems: collection.map((offerItem)=>(0, _utils.mapOfferItem)({
                offerItem,
                products,
                isAnonymousUser: customerTypeId === undefined || customerTypeId === 0
            })).filter((offerItem)=>offerItem !== null),
        totalRecords
    };
};
exports.getOfferItemsPage = getOfferItemsPage;
